import React, { useState } from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import googleOAuthService from './googleOAuthService.js';

interface GoogleSignupButtonProps {
  onSuccess: (userData: any) => void;
  onError: (error: Error) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const GoogleSignupButton: React.FC<GoogleSignupButtonProps> = ({
  onSuccess,
  onError,
  disabled = false,
  isLoading = false
}) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    if (disabled || isLoading || isGoogleLoading) return;

    setIsGoogleLoading(true);
    try {
      // Parse the credential response to extract user data
      const userData = googleOAuthService.parseCredentialResponse(credentialResponse);
      onSuccess(userData);
    } catch (error) {
      console.error('Google signup failed:', error);
      onError(error as Error);
    } finally {
      setIsGoogleLoading(false);
    }
  };

  const handleGoogleError = () => {
    console.error('Google signup error');
    onError(new Error('Failed to authenticate with Google. Please try again.'));
  };

  return (
    <div className="">
      {isGoogleLoading ? (
        <button
          type="button"
          className="btn btn-outline-danger btn-lg w-100 d-flex align-items-center justify-content-center"
          disabled
          style={{
            borderRadius: '12px',
            border: '2px solid #dc3545',
            height: '56px',
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          <div 
            className="spinner-border spinner-border-sm me-3" 
            role="status"
            style={{ width: '20px', height: '20px' }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          Connecting to Google...
        </button>
      ) : (
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={handleGoogleError}
          useOneTap={false}
          auto_select={false}
          theme="outline"
          size="large"
          text="signup_with"
          shape="rectangular"
          width="100%"
        />
      )}
    </div>
  );
};

export default GoogleSignupButton;